<template>
  <PageLayout>
    <template #main>
      <h2 class="text-h3 font-weight-bold navy--text text--darken-1 pb-10">
        Přihlašte se ke svému účtu
      </h2>

      <v-form>
        <v-text-field
          v-model="username"
          label="E-mail"
          outlined
          name="username"
          type="email"
        ></v-text-field>

        <v-text-field
          v-model="password"
          label="Heslo"
          :type="showPassword ? 'text' : 'password'"
          outlined
          name="password"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword = !showPassword"
        ></v-text-field>

        <v-alert
          v-if="apiResponseState.status > 200"
          type="error"
          outlined
          text
          class="mb-4"
        >
          <div v-if="apiResponseState.status === 404">
            Uživatelské jméno nebo heslo není správné. Zkuste se
            <router-link to="/register" class="link link-underline">
              zaregistrovat
            </router-link>
            nebo si
            <router-link to="/reset-password" class="link link-underline">
              obnovte heslo </router-link
            >.
          </div>
          <div v-else-if="apiResponseState.status === 403">
            Email tohoto účtu ještě nebyl ověřen. Zkontrolujte prosím svoji
            emailovou schránku a pokračujte dle pokynů v emailu.
          </div>
          <div v-else>
            Něco se pokazilo
          </div>
        </v-alert>
      </v-form>

      <div class="pb-8">
        <router-link to="reset-password" class="link link-underline navy--text">
          Nepamatujete si své heslo?
        </router-link>
      </div>

      <div class="text-center pb-10">
        <v-btn
          type="submit"
          :disabled="false"
          :loading="appLoginPending"
          color="primary"
          class="c-btn"
          @click="onLoginClick"
        >
          Přihlásit se
        </v-btn>
      </div>

      <div class="text-center">
        <span class="navy--text">Nemáte účet?</span>
        <router-link to="/register" class="link link-underline navy--text ml-2">
          Chci se zaregistrovat
        </router-link>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import { call, get, sync } from "vuex-pathify"

import PageLayout from "@/components/page/auth/PageLayout.vue"

const FB_REDIRECT_URL = window.location.origin + "/login?network=facebook"

export default {
  name: "Login",
  components: {
    PageLayout,
  },
  data() {
    return {
      showPassword: false,
    }
  },
  computed: {
    ...get("app", ["apiResponseState"]),
    ...get("auth", ["appLoginPending"]),
    ...sync("auth/credentialsModel@", ["username", "password"]),
  },
  methods: {
    ...call("app", ["resetApiResponseState"]),
    ...call("auth", ["getFacebookLogin", "login", "loginViaFacebookCode"]),
    onLoginClick() {
      this.login().then(() => {
        this.$router.push("/").catch(() => {})
      })
    },
    redirectToFacebook() {
      this.getFacebookLogin(FB_REDIRECT_URL).then(response => {
        if (response && response.loginUrl) {
          window.location.href = response.loginUrl
        }
      })
    },
  },
  mounted() {
    this.resetApiResponseState()

    // returned from FB login
    if (
      this.$router.currentRoute.query.network &&
      this.$router.currentRoute.query.code
    ) {
      this.loginViaFacebookCode({
        code: this.$router.currentRoute.query.code,
        redirectUrl: FB_REDIRECT_URL,
      })
    }
  },
}
</script>
